import gql from "graphql-tag";

export const topDevicesList = gql`
  query topDevicesList(
    $from: String
    $to: String
    $offset: Int
    $limit: Int
    $merchant_search: String
  ) {
    fraud {
      top_devices_by_volume(
        from: $from
        to: $to
        offset: $offset
        limit: $limit
        merchant_search: $merchant_search
      ) {
        average_tx
        lifetime_spend
        lifetime_spend_users
        token
        total_spend
        ratio_of_total_payments
        users {
          email
          external_reference
          dashboard_url
          snapmin_url
        }
        devices {
          external_reference
          device_only_fraud_status
        }
        top_merchants {
          id
          name
          merchant {
            merchant_limit_configuration {
              name
            }
          }
        }
      }
    }
  }
`;
